import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/product_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  style_number_cont: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.styleNumber',
  },
  number_cont: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.number',
  },
  product_category_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'product.productCategory',
    extra: {
      model_name: 'ProductCategory',
      display_column: 'name',
    },
    model_name: 'Product',
  },
  product_category: {
    column_type: 'belongs_to',
    label_key_path: 'product.productCategory',
    extra: {
      model_name: 'ProductCategory',
      display_column: 'name',
    },
    model_name: 'Product',
  },
  supplier_name_cont: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.supplierName',
  },
  vc_name_cont: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.vcName',
  },
}
export const formColumnsConfig = {
  'self': {
    'image': { required: true, disabledUpdate: false },
    'style_number': { required: true, disabledUpdate: false },
    'product_category_id': { required: true, disabledUpdate: false },
    'number': { required: false, disabledUpdate: false },
    'size_option_value_ids': { required: false, disabledUpdate: false },
    'supplier_name': { required: false, disabledUpdate: false },
    'vc_name': { required: false, disabledUpdate: false },
    'sales_price': { required: false, disabledUpdate: false },
    'cost_price': { required: false, disabledUpdate: false },
    'return_period': { required: false, disabledUpdate: false },
    'release_at': { required: false, disabledUpdate: false },
    'min_order_qty': { required: false, disabledUpdate: false },
    'fabric_cutting_count': { required: false, disabledUpdate: false },
    'color_option_value_list': { required: false, disabledUpdate: false },
    'variant_table_attributes': { required: false, disabledUpdate: false },
  },
  'variant_table_attributes': {
    'color': { required: false, disabledUpdate: false },
    'size_option_value_id': { required: false, disabledUpdate: false },
    'sku': { required: false, disabledUpdate: false },
    'min_order_qty': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Product', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Product', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
